import { type StaticDecode, Type } from 'typebox';
import { Image, MongoAndPgEntity } from 'schema/shared';

/**
 * The version of User returned from the API calls to examine usage of project fields on CVs
 */
export const UsageUser = Type.Interface([MongoAndPgEntity], {
  name: Type.Readonly(Type.String()),
  cv_id: Type.Readonly(Type.String()),
  can_write: Type.Readonly(Type.Boolean()),
  image: Type.Readonly(Image),
  project_experience_ids: Type.Readonly(Type.Array(Type.String())),
});
export type UsageUser = StaticDecode<typeof UsageUser>;
